module.exports = __webpack_public_path__ + "img/vlcsnap-2024-01-09-21h06m52s312.bc52d07a.png";